import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from "@msdyn365-commerce/retail-proxy";
import * as DataServiceEntities from './CustomEntities/GCOrderShipmentTrackingEntity';

function getSalesOrderTrackingInfoQuery(): DataServiceQuery {
      return new DataServiceQuery();
      }


export function getSalesOrderTrackingInfoInput (
    apiConfiguration:
        DataServiceEntities.IAPIConfiguration,
        salesId:
        string
): IDataServiceRequest {
  const query = getSalesOrderTrackingInfoQuery();
  return query.createDataServiceRequestForOperation(
      'GetSalesOrderTrackingInfo',
      true,
        DataServiceEntities.GCOrderTrackingInfoExtensionClass
      ,
      'false',
      { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGCOrderTrackingInfo' },
      {
      apiConfiguration: apiConfiguration,
        salesId: salesId
      }
  );
}

export function getSalesOrderTrackingInfoAsync (
    context: IContext, apiConfiguration:
        DataServiceEntities.IAPIConfiguration,
        salesId:
        string
    ): AsyncResult<DataServiceEntities.IGCOrderTrackingInfo> {
    const request = getSalesOrderTrackingInfoInput(apiConfiguration, salesId);
    return callActionOrExecute<DataServiceEntities.IGCOrderTrackingInfo>(request, context.callerContext);
    }